module.exports = __webpack_public_path__ + "img/mirkatravel_logo.4e35dd85.jpg";